import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiPatch, operationsClient } from '@/lib/api';
import type { LeadStage, UpdateLeadPipelineStageDto } from '@/types/lead';

export function useUpdateLeadPipelineStage() {
  const queryClient = useQueryClient();

  return useApiMutation<LeadStage, UpdateLeadPipelineStageDto>({
    mutationFn: ({ id, ...dto }) =>
      apiPatch<LeadStage, Omit<UpdateLeadPipelineStageDto, 'id'>>(
        operationsClient,
        leadEndpoints.stageDetail(id),
        dto,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leadKeys.stages() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
      toast.success('Lead stage saved');
    },
  });
}
